export function classNames(...classes: Array<string | false | null | undefined>) {
    return classes.filter(Boolean).join(" ");
  }
  
  export function formatEUR(value: number) {
    return new Intl.NumberFormat("it-IT", {
      style: "currency",
      currency: "EUR",
      maximumFractionDigits: 2,
    }).format(value);
  }
  
  export function formatCurrency(value: number, currencyCode: 'EUR' | 'USD') {
    return new Intl.NumberFormat('it-IT', {
      style: 'currency',
      currency: currencyCode,
      maximumFractionDigits: 2,
    }).format(value);
  }

export function formatOunces(value: number | null | undefined): string {
    if (value === null || value === undefined || isNaN(value)) {
      return '0.000';
    }
    return value.toFixed(3);
  }
  